export enum EProjectionActionType {
  LOAD_PROJECTION_SYSTEMS = 'PROJECTION_SYSTEMS/LOAD',
  LOADING_PROJECTION_SYSTEMS = 'PROJECTION_SYSTEMS/LOADING',
  SET_PROJECTION_SYSTEMS = 'PROJECTION_SYSTEMS/SET',
  GET_PROJECTION_SYSTEMS_BY_ID = 'PROJECTION_SYSTEMS/GET_BY_ID',
  FILTER_PROJECTION_SYSTEMS = 'PROJECTION_SYSTEMS/FILTER',
  SET_SELECTED_PROJECTION_SYSTEMS = 'PROJECTION_SYSTEMS/SELECTED',
}
